export const bloodTests = [
  {
    name: "Women's Hormone Panel",
    desc: "Oestrogen, progesterone, FSH, LH, testosterone, SHBG",
    price: "£89",
    url: "https://www.medichecks.com/?ref=hormonely",
    best: "Women in their 40s — the best starting point for perimenopause",
  },
  {
    name: "Men's Hormone Panel",
    desc: "Total & free testosterone, SHBG, FSH, LH, prolactin",
    price: "£69",
    url: "https://www.medichecks.com/?ref=hormonely",
    best: "Men in their 40s — includes free testosterone, which standard tests miss",
  },
  {
    name: "Full Thyroid Panel",
    desc: "TSH, free T3, free T4, TPO antibodies",
    price: "£49",
    url: "https://www.medichecks.com/?ref=hormonely",
    best: "Anyone with fatigue, weight gain or brain fog — rules out thyroid dysfunction",
  },
  {
    name: "Advanced Well Woman",
    desc: "Full hormones + thyroid + vitamin D + iron + cholesterol",
    price: "£149",
    url: "https://www.medichecks.com/?ref=hormonely",
    best: "Women in their 50s — the most complete baseline available",
  },
  {
    name: "Advanced Well Man",
    desc: "Full hormones + thyroid + PSA + cholesterol + metabolic",
    price: "£129",
    url: "https://www.medichecks.com/?ref=hormonely",
    best: "Men in their 50s — covers everything worth knowing at this decade",
  },
  {
    name: "Vitamin D Test",
    desc: "25-OH vitamin D",
    price: "£29",
    url: "https://www.medichecks.com/?ref=hormonely",
    best: "Anyone with persistent fatigue — vitamin D deficiency is frequently overlooked",
  },
];
